module.exports = __webpack_public_path__ + "img/close_over.2f8044ec.png";